export default __webpack_public_path__ + "static/media/kz.64e40aca.svg";